import Vue from "vue";
import Router from "vue-router";
import Main from "@/Main.vue";
import home from "@/views/home.vue";
const Works = () => import("@/views/works.vue");
const usercentersetting = () => import("@/views/usercentersetting.vue");
const usercenter = () => import("@/views/usercenter.vue");
const uploadwork = () => import("@/views/uploadwork.vue");
const footernav = () => import("@/views/footernav.vue");
const worksdetail = () => import("@/views/WorksDetail.vue");
const newslist = () => import("@/views/newslist.vue");
const search = () => import("@/views/search.vue");
const toollist = () => import("@/views/toollist.vue");
const articledetail = () => import("@/views/articledetail.vue");
const activitydetail = () => import("@/views/activitydetail.vue");
const resourceIndex = () => import("@/views/resource-module/index.vue");
const resourceDetail = () => import("@/views/resource-module/detail.vue");
const resourceDown = () => import("@/views/resource-module/download.vue");
const payDownload = () => import("@/views/down-load-module/PayDownload.vue");
const pluginDownload = () => import("@/views/download.vue");

const clickDownLoad = () =>
  import("@/views/down-load-module/ClickDownLoad.vue");

const download = () => import("@/views/personCenter-module/Download.vue");
import courseRouter from "./course/index";
import weekRouter from "./week/index";
import businessComperationRouter from "./businessComperation/index";
import personalCenterRouter from "./personalCenter/index";
const softwareIndex = () => import("@/views/software-module/index.vue");
const newsIndex = () => import("@/views/news-module/index.vue");
const newsDetail = () => import("@/views/news-module/detail.vue");
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
// import BaiduMap from "@/views/baiduMap.vue"
Vue.use(Router);

export default new Router({
  mode: "history",
  base: "",
  routes: [{
      path: "/",
      component: Main,
      children: [{
        path: "/",
        name: "home",
        component: home,
        meta: {
          title: "首页"
        }
      }]
    },
    {
      path: "/plugin/download",
      name: "pluginDownload",
      component: pluginDownload,
      meta: {
        title: "图象超级助理"
      }
    },
    {
      path: "/Main",
      name: "Main",
      component: Main,
      children: [{
          path: "/home",
          name: "home",
          component: home,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/design/works",
          name: "Works",
          component: Works,
          meta: {
            title: "作品"
          }
        },

        {
          path: "/design/usercenter",
          name: "usercenter",
          component: usercenter,
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "/design/usercentersetting",
          name: "usercentersetting",
          component: usercentersetting,
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "/design/toollist",
          name: "toollist",
          component: toollist,
          meta: {
            title: "工具"
          }
        },
        {
          path: "/resource/index",
          name: "resourceIndex",
          component: resourceIndex,
          meta: {
            title: "资源"
          }
        },
        {
          path: "/resource/detail/:id",
          name: "resourceDetail",
          component: resourceDetail,
          meta: {
            title: "资源详情"
          }
        },
        {
          path: "/resource/download",
          name: "resourceDown",
          component: resourceDown,
          meta: {
            title: "下载"
          }
        },
        // {
        //   path: "/design/newslist",
        //   name: "newslist",
        //   component: newslist,
        //   meta: {
        //     title: "公告列表"
        //   }
        // },
        {
          path: "/design/articledetail",
          name: "articledetail",
          component: articledetail,
          meta: {
            title: "文章详情"
          }
        },
        {
          path: "/design/activitydetail",
          name: "activitydetail",
          component: activitydetail,
          meta: {
            title: "活动详情"
          }
        },
        {
          path: "/design/worksdetail",
          name: "worksdetail",
          component: worksdetail,
          meta: {
            title: "文章详情"
          }
        },
        {
          path: "/design/search",
          name: "search",
          component: search,
          meta: {
            title: "搜索"
          }
        },
        {
          path: "/design/uploadwork",
          name: "uploadwork",
          component: uploadwork,
          meta: {
            title: "上传作品"
          }
        },
        {
          path: "/design/footernav",
          name: "footernav",
          component: footernav,
          meta: {
            title: ""
          }
        },
        {
          path: "/design/payDownload",
          name: "payDownload",
          component: payDownload,
          meta: {
            title: "支付下载页面"
          }
        },
        {
          path: "/design/clickDownLoad",
          name: "clickDownLoad",
          component: clickDownLoad,
          meta: {
            title: "点击下载页面"
          }
        },
        {
          path: "/software/index",
          name: "softwareIndex",
          component: softwareIndex,
          meta: {
            title: "软件下载"
          }
        },
        {
          path: "/news/index",
          name: "newsIndex",
          component: newsIndex,
          meta: {
            title: "新闻事迹"
          }
        },
        {
          path: "/news/detail",
          name: "newsDetail",
          component: newsDetail,
          meta: {
            title: "新闻详情"
          }
        },
        {
          path: "/upload/main",
          name: "uploadmain",
          component: () => import('@/views/upload-module/upload-main'),
          meta: {
            title: "上传记录"
          }
        },
        {
          path: "/upload/page",
          name: "uploadpage",
          component: () => import('@/views/upload-module/upload-page'),
          meta: {
            title: "素材上传"
          }
        },
        ...weekRouter,
        ...courseRouter,
        ...businessComperationRouter,
        ...personalCenterRouter
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js